import ApiService from "./ApiService";

export async function apiValidateToken(data) {
    return ApiService.fetchData({
        url: "/auth/validateToken",
        method: "get",
    });
}

export async function apiGetTransactionModes() {
    return ApiService.fetchData({
        url: "/admin/getTransactionModes",
        method: "get",
    });
}

export async function apiGetBusinessTypes() {
    return ApiService.fetchData({
        url: "/admin/getBusinessTypes",
        method: "get",
    });
}

export async function apiGetProfile() {
    return ApiService.fetchData({
        url: "/dashboard/getProfile",
        method: "get",
    });
}


//Internal Development
// export async function apiGetProfile() {
//     return ApiService.fetchData({
//         url: "/dashboard/getProfile",
//         method: "get",
//     });
// }
